import { JBaseApi } from '../base';
import { ApiWrapper } from '../../types';
import { OF } from '../../util/network';
import { ExternalAppType } from '../../types/externalApp';

export class JExternalAppApi extends JBaseApi {
    public save(
        payload: Omit<ExternalAppType, 'id'> & { id?: string },
        params?: { signal?: AbortSignal },
    ): Promise<ApiWrapper<ExternalAppType>> {
        return this.network.postCSRF(
            {
                o: 'externalApp',
                f: 'save',
                ...payload,
            } as OF,
            params?.signal,
        );
    }

    public list(params?: { signal?: AbortSignal }): Promise<ApiWrapper<Record<string, ExternalAppType>>> {
        return this.network.post(
            {
                o: 'externalApp',
                f: 'list',
            } as OF,
            params?.signal,
        );
    }

    public delete(payload: { id: string }, params?: { signal?: AbortSignal }): Promise<ApiWrapper<boolean>> {
        return this.network.postCSRF(
            {
                o: 'externalApp',
                f: 'delete',
                ...payload,
            } as OF,
            params?.signal,
        );
    }
}
